/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    VccCredentialsListConfiguration,
    VccCredentialsListConfigurationFromJSON,
    VccCredentialsListConfigurationToJSON,
    VccCredentialsListItem,
    VccCredentialsListItemFromJSON,
    VccCredentialsListItemToJSON,
    VccCredentialsListItemPaginationWrapper,
    VccCredentialsListItemPaginationWrapperFromJSON,
    VccCredentialsListItemPaginationWrapperToJSON,
    VccCredentialsQuery,
    VccCredentialsQueryFromJSON,
    VccCredentialsQueryToJSON,
    VccCredentialsV2Query,
    VccCredentialsV2QueryFromJSON,
    VccCredentialsV2QueryToJSON,
    VccCredentialsV2State,
    VccCredentialsV2StateFromJSON,
    VccCredentialsV2StateToJSON,
    VccCredentialsV2StateResponse,
    VccCredentialsV2StateResponseFromJSON,
    VccCredentialsV2StateResponseToJSON,
} from '../models';

export interface ApiVccCredentialsListListPostRequest {
    vccCredentialsQuery?: VccCredentialsQuery;
}

export interface ApiVccCredentialsListListV2PostRequest {
    vccCredentialsV2Query?: VccCredentialsV2Query;
}

export interface ApiVccCredentialsListUpdateStateBulkPostRequest {
    vccCredentialsV2State: Array<VccCredentialsV2State>;
}

/**
 * no description
 */
export class VccCredentialsListApi extends runtime.BaseAPI {

    /**
     */
    async apiVccCredentialsListConfigurationGetRaw(): Promise<runtime.ApiResponse<VccCredentialsListConfiguration>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/VccCredentialsList/Configuration`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => VccCredentialsListConfigurationFromJSON(jsonValue));
    }

    /**
     */
    async apiVccCredentialsListConfigurationGet(): Promise<VccCredentialsListConfiguration> {
        const response = await this.apiVccCredentialsListConfigurationGetRaw();
        return await response.value();
    }

    /**
     */
    async apiVccCredentialsListListPostRaw(requestParameters: ApiVccCredentialsListListPostRequest): Promise<runtime.ApiResponse<Array<VccCredentialsListItem>>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/VccCredentialsList/List`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: VccCredentialsQueryToJSON(requestParameters.vccCredentialsQuery),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(VccCredentialsListItemFromJSON));
    }

    /**
     */
    async apiVccCredentialsListListPost(requestParameters: ApiVccCredentialsListListPostRequest): Promise<Array<VccCredentialsListItem>> {
        const response = await this.apiVccCredentialsListListPostRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiVccCredentialsListListV2PostRaw(requestParameters: ApiVccCredentialsListListV2PostRequest): Promise<runtime.ApiResponse<VccCredentialsListItemPaginationWrapper>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/VccCredentialsList/ListV2`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: VccCredentialsV2QueryToJSON(requestParameters.vccCredentialsV2Query),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => VccCredentialsListItemPaginationWrapperFromJSON(jsonValue));
    }

    /**
     */
    async apiVccCredentialsListListV2Post(requestParameters: ApiVccCredentialsListListV2PostRequest): Promise<VccCredentialsListItemPaginationWrapper> {
        const response = await this.apiVccCredentialsListListV2PostRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiVccCredentialsListUpdateStateBulkPostRaw(requestParameters: ApiVccCredentialsListUpdateStateBulkPostRequest): Promise<runtime.ApiResponse<Array<VccCredentialsV2StateResponse>>> {
        if (requestParameters.vccCredentialsV2State === null || requestParameters.vccCredentialsV2State === undefined) {
            throw new runtime.RequiredError('vccCredentialsV2State','Required parameter requestParameters.vccCredentialsV2State was null or undefined when calling apiVccCredentialsListUpdateStateBulkPost.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/VccCredentialsList/UpdateStateBulk`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.vccCredentialsV2State.map(VccCredentialsV2StateToJSON),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(VccCredentialsV2StateResponseFromJSON));
    }

    /**
     */
    async apiVccCredentialsListUpdateStateBulkPost(requestParameters: ApiVccCredentialsListUpdateStateBulkPostRequest): Promise<Array<VccCredentialsV2StateResponse>> {
        const response = await this.apiVccCredentialsListUpdateStateBulkPostRaw(requestParameters);
        return await response.value();
    }

}
